var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-neighbourhood-nav"},[_c('div',{staticClass:"c-neighbourhood-nav__inner"},[_c('neighbourhood-nav-btn')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }